import { Button } from "@/components/ui/button";
import { StatusBanner } from "@/components/ui/surface";
import type { ReplayLoadProgress } from "@/hooks/use-server-replay";

export function ReplayLoadStatus({ progress, onRetry }: {
  progress?: ReplayLoadProgress;
  onRetry?: (() => void) | null;
}) {
  if (!progress?.failedRounds) return null;
  return <StatusBanner tone="warning" className="m-2 shrink-0 sm:mx-4">
    <div className="flex flex-wrap items-center justify-between gap-2">
      <p>{progress.failedRounds} round{progress.failedRounds === 1 ? "" : "s"} could not load. {progress.readyRounds}/{progress.totalRounds} rounds playable.</p>
      {onRetry ? <Button variant="outline" disabled={progress.isBackgroundLoading} onClick={onRetry}>
        {progress.isBackgroundLoading ? "Retrying rounds…" : "Retry missing rounds"}
      </Button> : null}
    </div>
  </StatusBanner>;
}
